import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'
import dayjs from 'dayjs'

class VendorSetupType extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._id = init.id
    this._employee_id = init.employee_id
    this._changes_type = init.changes_type
    this._client_name = init.client_name
    this._implementation_date = init.implementation_date
    this._vendor_name = init.vendor_name
    this._vendor_type = init.vendor_type
    this._source_attachments = init.source_attachments
    this._updated_at = init.updated_at
    this._contact_email = init.contact_email
    this._contact_name = init.contact_name
    this._layout_type = init.layout_type
    this._sftp = init.sftp
  }

  static shape = {
    id: PropTypes.number,
    employee_id: PropTypes.number,
    changes_type: PropTypes.string,
    client_name: PropTypes.string,
    implementation_date: PropTypes.string,
    vendor_name: PropTypes.string,
    vendor_type: PropTypes.string,
    source_attachments: PropTypes.arrayOf(PropTypes.string),
    updated_at: PropTypes.number,
    contact_email: PropTypes.string,
    contact_name: PropTypes.string,
    layout_type: PropTypes.string,
    sftp: PropTypes.string
  }

  get id() {
    return this._id
  }

  get employee_id() {
    return this._employee_id
  }

  get changes_type() {
    return this._changes_type
  }

  get client_name() {
    return this._client_name
  }

  get implementation_date() {
    return dayjs(new Date(this._implementation_date).toISOString())
  }

  get vendor_name() {
    return this._vendor_name
  }

  get vendor_type() {
    return this._vendor_type
  }

  get source_attachments() {
    return this._source_attachments
  }

  get updated_at() {
    return this._updated_at
  }

  get contact_email() {
    return this._contact_email
  }

  get contact_name() {
    return this._contact_name
  }

  get layout_type() {
    return this._layout_type
  }

  get sftp() {
    return this._sftp
  }
}

export default VendorSetupType
